import { LoadingButton } from "@mui/lab";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import PostHooks from "../../../Api/PostHooks";
import ActionDialog from "../../../Components/ActionDialog";
import PaymentIcon from "@mui/icons-material/Payment";
import SavingsIcon from "@mui/icons-material/Savings";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import OutboxIcon from "@mui/icons-material/Outbox";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import EnhancedEncryptionIcon from "@mui/icons-material/EnhancedEncryption";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Lock } from "@mui/icons-material";
import AlertComponent from "../../../Components/AlertComponent";

const UserActions = ({ _user, fetchData }) => {
  const location = useLocation();
  const LoggedInUser = useSelector((state) => state.auth.user);

  const [dialog, setDialog] = useState({
    open: false,
    type: null,
    label: null,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const [user, setUser] = useState(_user);

  const [activateLoading, , activateRequest] = PostHooks();

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const openDialog = (type, label) => setDialog({ open: true, type, label });
  const closeDialog = () => setDialog({ open: false, type: null, label: null });

  const actionButtons = [
    {
      type: "deposit",
      label: "Wallet Deposit",
      color: "info",
      icon: PaymentIcon,
      allowedRoles: ["customer"],
    },
    {
      type: "save",
      label: "Boost Savings",
      color: "success",
      icon: SavingsIcon,
      allowedRoles: ["customer"],
    },
    {
      type: "apply_loan",
      label: "Apply Loan",
      color: "info",
      icon: RequestQuoteIcon,
      allowedRoles: ["customer"],
    },
    {
      type: "repay",
      label: "Repay Loan",
      color: "error",
      icon: CurrencyExchangeIcon,
      allowedRoles: ["customer"],
    },
    {
      type: "pool_fund",
      label: "Pool Fund",
      color: "primary",
      icon: GroupWorkIcon,
      allowedRoles: ["customer"],
    },
    {
      type: "withdraw_pool_fund",
      label: "Withdraw Pool Fund",
      color: "warning",
      icon: OutboxIcon,
      allowedRoles: ["customer"],
    },
    {
      type: "airtime",
      label: "Purchase Airtime",
      color: "secondary",
      icon: SmartphoneIcon,
      allowedRoles: ["customer"],
    },
    {
      type: "boost_shares",
      label: "Boost Shares",
      color: "success",
      icon: TrendingUpIcon,
      allowedRoles: ["customer"],
    },
    {
      type: "edit_profile",
      label: "Edit Profile",
      color: "info",
      icon: EditNoteIcon,
      allowedRoles: ["admin", "ccr", "finance"],
    },
    {
      type: "send_sms",
      label: "Send SMS",
      color: "primary",
      icon: OutboxIcon,
      allowedRoles: ["admin", "ccr", "finance"],
    },
    {
      type: "exit",
      label: "Exit",
      color: "error",
      icon: ExitToAppIcon,
      allowedRoles: ["admin"],
    },
    {
      type: "block",
      label: "Block",
      color: "error",
      icon: Lock,
      allowedRoles: ["admin", "ccr", "finance"],
    },
    {
      type: "unblock",
      label: "Unblock",
      color: "secondary",
      icon: LockOpenIcon,
      allowedRoles: ["admin", "ccr", "finance"],
    },
    // {
    //   type: "unsuspend_acc",
    //   label: "Unsuspend",
    //   color: "secondary",
    //   icon: LockOpenIcon,
    //   allowedRoles: ["admin"],
    // },
    // {
    //   type: "reset_pin",
    //   label: "Reset Pin",
    //   color: "error",
    //   icon: EnhancedEncryptionIcon,
    //   allowedRoles: ["admin", "ccr", "finance"],
    // },
  ];

  const handleActivateKyc = async () => {
    try {
      const actResp = await activateRequest({
        url: "/approve_profile",
        body: { username: user.username },
      });

      if (actResp && actResp.status === 200 && actResp.data.StatusCode === 0) {
        setSnackbar({
          open: true,
          message: "Account activated successfully!",
          severity: "success",
        });
        fetchData();
      } else {
        const errorMessage =
          actResp?.data?.StatusMessage ??
          actResp?.data?.message ??
          "An unexpected error occurred. Please try again.";

        setSnackbar({
          open: true,
          severity: "error",
          message: errorMessage,
        });
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  return (
    <>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <ActionDialog
        open={dialog.open}
        onClose={closeDialog}
        dialogType={dialog.type}
        dialogLabel={dialog.label}
        user={user}
        onSuccess={() => fetchData()}
      />

      {/* <Card
        sx={{
          borderRadius: 3,
          boxShadow: "0 4px 18px rgba(0,0,0,0.08)",
          backgroundColor: "#fff",
          p: 2,
        }}
      >
        <CardHeader
          title={<Typography variant="h5">Quick Actions</Typography>}
        />
        <CardContent> */}
      <Grid
        container
        spacing={1}
        display={"flex"}
        justifyContent={{ xs: "flex-start", sm: "flex-end" }}
        alignItems={"center"}
      >
        {["admin", "ccr"].includes(LoggedInUser?.role) &&
          user.kyc_status !== "active" && (
            <Grid item>
              <LoadingButton
                variant="contained"
                color="success"
                onClick={handleActivateKyc}
                loading={activateLoading}
              >
                Activate KYC
              </LoadingButton>
            </Grid>
          )}

        {actionButtons
          .filter((action) => action.allowedRoles.includes(LoggedInUser?.role))
          .map((action, i) => (
            <Grid item key={i}>
              <Button
                key={i}
                size="small"
                variant="outlined"
                startIcon={<action.icon color={action.color} />}
                onClick={() => openDialog(action.type, action.label)}
              >
                {action.label}
              </Button>
            </Grid>
          ))}
      </Grid>
      {/* </CardContent>
      </Card> */}
    </>
  );
};

export default UserActions;
